// src/app/core/utils/wa.ts
export const WA_NUMBER_E164 = '59899448469';

export function buildWhatsAppLink(text: string): string {
  const encoded = encodeURIComponent(text.trim());
  return `https://wa.me/${WA_NUMBER_E164}?text=${encoded}`;
}
